import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
    Input,
    Select
} from '../../../../../../../_metronic/_partials/controls';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../../_metronic/_partials/controls';
import { RoleChecker, RoleCheckerNoRedux } from '../../../../../../RoleChecker';
import { copyValue } from "../../../../../../../_metronic/_helpers/UtilityHelpers";
import { categoryHewan, tipeHewan } from '../HewanKurbanCampaignUIHelpers';
import CurrencyInput from 'react-currency-input-field';
import { getHewanKurbanAll } from '../../../../_redux/hewan-kurban/hewanKurbanCrud';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import { getBranchAll } from '../../../../../MasterData/_redux/branchs/branchCrud';





// Validation schema
const HewanKurbanCampaignEditSchema = Yup.object().shape({
    name: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Nama Hewan Kurban Campaign Wajib Diisi'),
    price: Yup.number().min(1, "Harga Tidak Boleh Kurang Dari Sama Dengan 0").required('Harga wajib diisi'),
    thk_livestock_uuid: Yup.string().required('Hewan Kurban Campaign Wajib Diisi'),
});

export function HewanKurbanCampaignEditForm({ saveHewanKurbanCampaign, actionsLoading, hewanKurbanCampaign, roleMaster, onHide, id }) {

    const [LivestockList, setLivestockList] = useState([])
    const [branch, setBranch] = useState([]);


    const getHewanKurbanList = async () => {
        const response = await getHewanKurbanAll()
        if (response) {
            setLivestockList(response.data.data)
        }
    }
    const fetchBranch = async () => {
        const result = await getBranchAll();
        setBranch(result.data.data);
    };

    useEffect(() => {

        fetchBranch();
        getHewanKurbanList()
    }, [])

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={hewanKurbanCampaign}
                validationSchema={HewanKurbanCampaignEditSchema}
                onSubmit={(values) => {
                    // console.log(values);
                    saveHewanKurbanCampaign(values)

                }}
            >
                {({ handleSubmit, values, setFieldValue, handleChange }) => (
                    <>

                        <Modal.Body className="overlay overlay-block cursor-default">
                            {actionsLoading && (
                                <div className="overlay-layer bg-transparent">
                                    <div className="spinner spinner-lg spinner-success" />
                                </div>
                            )}
                            <Form className="form form-label-right">
                                <div className="form-group row">
                                    <div className="col-lg-12 mb-1">
                                        <label><strong>Nama Hewan Kurban</strong></label>
                                        <input
                                            className='form-control'
                                            name="name"
                                            placeholder="Text"
                                            value={values.name}
                                            onChange={e => setFieldValue(e.target.name, e.target.value)}
                                            label="Nama Hewan Kurban Campaign"
                                        />
                                    </div>
                                </div>

                                    <div className='form-group row'>
                                    <div className="col-lg-12 mb-1">
                                        <label htmlFor="thk_livestock_uuid"><strong>Kategori Hewan</strong></label>
                                        <Autocomplete
                                            name="thk_livestock_uuid"
                                            options={LivestockList}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, value) => {
                                                if (value) {
                                                    setFieldValue('thk_livestock_uuid', value.uuid)

                                                } else {
                                                    setFieldValue('thk_livestock_uuid', "")
                                                }
                                            }}
                                            value={LivestockList.length > 0 && LivestockList.find((item) => item.uuid === values.thk_livestock_uuid)}
                                            // loading={LivestockList.length === 0 ? true : false}

                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Pilih Hewan Kurban"
                                                    variant="outlined"
                                                    disableClearable
                                                    size="small"

                                                />
                                            )}
                                        />
                                        <ErrorMessage name='thk_livestock'
                                            render={msg => <div style={{ color: 'red', }}>{msg}</div>} />
                                    </div>
                                    </div>
                                    {/* <div className="col-lg-12 mb-1">

                                        <label>Harap Pilih <b>Branch</b></label>
                                        <Autocomplete
                                            name="branch_uuid"
                                            options={branch}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, value) => {
                                                if (value) {
                                                    setFieldValue('branch_uuid', value.uuid)
                                                } else {
                                                    setFieldValue('branch_uuid', "")
                                                }
                                            }}
                                            value={branch.length > 0 && branch.find((item) => item.uuid === values.branch_uuid)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Pilih Branch"
                                                    variant="outlined"
                                                    disableClearable
                                                    size="small"

                                                />
                                            )}
                                        />
                                        <label>Harap Masukkan <b>Branch</b></label>
                                    </div> */}
                                    <div className='form-group row'>

                                    <div className="col-lg-12 mb-1">

                                        <label htmlFor="price"><strong>Harga Jual</strong></label>
                                        <CurrencyInput
                                            name="price"
                                            placeholder="Harga Hewan Kurban Campaign"
                                            intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                            className="form-control"
                                            defaultValue={values.price}
                                            value={values.price}
                                            decimalsLimit={2}
                                            label="Jumlah"
                                            onValueChange={(value, name) => {
                                                if (value) {
                                                    setFieldValue(name, Number(value))
                                                } else {
                                                    setFieldValue(name, 0)
                                                }
                                            }}
                                        />
                                        <ErrorMessage name='price'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                    </div>
                                    </div>


                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                Cancel
                            </button>
                            <> </>
                            <button
                                type="submit"
                                onClick={() => handleSubmit()}
                                className="btn btn-primary btn-elevate"
                            >
                                Save
                            </button>
                        </Modal.Footer>
                    </>
                )}
            </Formik>
        </>
    );
}

